/**
 * @generated SignedSource<<525a2bd50e1f51afbb59a91a52dde7d6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useShouldShowAddToCalendar_itemSearch$data = {
  readonly isCollectionAuction: boolean | null;
  readonly publicationStartDate: string | null;
  readonly " $fragmentType": "useShouldShowAddToCalendar_itemSearch";
};
export type useShouldShowAddToCalendar_itemSearch$key = {
  readonly " $data"?: useShouldShowAddToCalendar_itemSearch$data;
  readonly " $fragmentSpreads": FragmentRefs<"useShouldShowAddToCalendar_itemSearch">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useShouldShowAddToCalendar_itemSearch",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "publicationStartDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isCollectionAuction",
      "storageKey": null
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};

(node as any).hash = "18b1d0b7cc5eb535515221d0a0bb8135";

export default node;
